import React, { useState, useEffect } from "react";
import { Dropdown, DropdownButton, Alert } from "react-bootstrap";
import useSelectionStore from "../../store/useSelectionStore";
import { useDatasets } from "../../hooks/useDatasets";
import { useTranslation } from "react-i18next";
import "../../i18n";

// Display name mapping for categories (API value -> UI display name)
const CATEGORY_DISPLAY_NAMES = {
  fusion: "Spatial temporal analysis",
};

// Helper function to get display name for a category
const getCategoryDisplayName = (category) => {
  return CATEGORY_DISPLAY_NAMES[category] || category;
};

const DatasetSelector = () => {
  const { getAvailableDatasets } = useDatasets();
  const { setSelectedDataset, setCategoriUpdate } = useSelectionStore();
  const [categories, setCategories] = useState([]);
  const [filteredDatasets, setFilteredDatasets] = useState([]);
  const [listOfDatasets, setListOfDatasets] = useState([]);
  const [chosenCategory, setChosenCategory] = useState("Select Use Case");
  const [chosenCategoryDisplay, setChosenCategoryDisplay] = useState("Select Use Case");
  const [chosenDataset, setChosenDataset] = useState("Select Dataset");
  const [alert, setAlert] = useState(null);
  const [categoriUpdate, setLocalCategoryUpdate] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    const fetchDatasets = async () => {
      try {
        const data = await getAvailableDatasets();

        const excludedIds = [
          "6662f7220d3695c721a6ed63", // old ID
          "67d2dd176bf1459221215df7", // old ID
          "668fdd0a5c9e12e279b1bd3d", // 2006
          "668fdd14361da16f02cd43b2", // 2007
          "668fdd1a2b86705ee75b522f", // 2008
          "668fdca47f91b1bcd4b5f700", // 2005
          "668fdd200c96f690f27ee1ef", // 2009
          "668fdd34cbefdf01597190b0", // 2011
          "668fdd280746b9f2421ae443", // 2010
          "668fdd3989ca7d08d7708874", // 2012
          "668fdd3f9ed9f989999102ff", // 2013
          "668fdd4a009daebafc69e1a3", // 2015
          "668fdd44682a4e45ed4acf63", // 2014
          "668fdd4f7317e47b448741e2", // 2016
          "668fdd54ddac766486072d2c", // 2017
          "668fdd580c80d4546cb4b689", // 2018
          "668fdd619bc3a8d20cf41999", // 2019
          "67f78aeb2a2612f264855453", //2005
          "67f78aebb602314a905b0ff8", //2006
          "67f78aec02ee2ea385951f85", //2007
          "67f78aec9c7f851e9efc75d1", //2008
          "67f78aec8dcb5f3ce1ff655f", //2009
          "67f78aec528d858640ca8551", //2010
          "67f78aec906b97372f235cd7", //2011
          "67f78aecbf5d4389e24c6d3e", //2012
          "67f78aece80f3de92bfd1275", //2013
          "67f78aeccbcfd8de2784dafd", //2014
          "67f78aecfb95086778556ce7", //2015
          "67f78aec1635148c51ae4896", //2016
          "67f78aecadcd9fea52154701", //2017
          "67f78aecb85d066cd412c4f1", //2018
          "67f78aecec9529b78acb163d", //2019
          "67f7babfaa74ec1ee95a727c", //2005
          "67f7babfda262db40a7baf52", //2006
          "67f7babf837aef44b2fa745d", //2007
          "67f7babfd469643b06377801", //2008
          "67f7babf75e851b9df1d2eae", //2009
          "67f7babf4b6360f5112760cd", //2010
          "67f7babf85cdae046d65cc28", //2011
          "67f7babfb2357e3bd97bd4a3", //2012
          "67f7bac02388df161830f22c", //2013
          "67f7bac04a65c2f33072e697", //2014
          "67f7bac0b724ac09221a68b4", //2015
          "67f7bac0277a0acf65c51daf", //2016
          "67f7bac093ff3ace697cd64c", //2017
          "67f7bac024c3fa7efe88884a", //2018
          "67f7bac0ceddb96805bd20dc", //2019
          // "6825a25ea9f013b4ce99f1d4", //2016 crc
          // "6825a25eed4b7e2268cf65af", //2017 crc
          // "6825a25e56e9c62993ec3b8a", //2018 crc
          // "6825a25e3524a9d0d7def9df", //2019 crc
          // "6825a25e1fdd6e1645d49279", //2020 crc
          // "6825a25e55161de543c720cd", //2021 crc
          // "6825a28f67be2a5c295e504a", //2022 crc
          // "6825a28f379ee281fd7782d4", //2023 crc
          // "6825a28f9e706ac260993b7a", //2024 crc
          // "6825a28f4233c8015c75c888", //2025 crc
          // "6825a28f4233c8015c75c888", //2026 crc
          // "6825a28f4ae6de6385e52ead", //2027 crc
          // "6825a28fdb096ec7cdea7326", //2028 crc

          // "6825a25e1fdd6e1645d49279", //2029 crc
          // "6825a25e55161de543c720cd",
          // "6825a2a2bc6a284fb2e63cdc",
          // "6825a2a26360a49133a6fe40", //2020 crc
          // "6825a2a2740174debb27a33d",
          // "6825a2a2bede24fc7294e39f",
          // "6825a2a22212696ea0ff12b8",
          // "6825a2a266e7a6542c2e5d32",
        ];

        const filteredData = data.filter(
          (item) =>
            !excludedIds.includes(item.id) &&
            item.category !== "hide it from dropdown" &&
            item.category !== "Dashboard"
        );

        setListOfDatasets(filteredData);
        setCategories([...new Set(filteredData.map((item) => item.category))]);
      } catch (error) {
        console.error("Error fetching datasets", error);
      }
    };

    fetchDatasets();
    // eslint-disable-next-line
  }, []);

  const handleCategorySelection = (selectedCategory) => {
    setChosenCategory(selectedCategory);
    setChosenCategoryDisplay(getCategoryDisplayName(selectedCategory));
    setChosenDataset("Select Dataset");
    setFilteredDatasets(
      listOfDatasets.filter((dataset) => dataset.category === selectedCategory)
    );
    setLocalCategoryUpdate(true);
    setCategoriUpdate(selectedCategory); // Update the store with category update
  };

  const handleDatasetSelection = (selectedDatasetName) => {
    if (chosenCategory === "Select Use Case") {
      setAlert({
        variant: "danger",
        message: "Please first select a Use Case.",
      });
      return;
    }

    setChosenDataset(selectedDatasetName);
    const selectedDataset = filteredDatasets.find(
      (dataset) => dataset.datasetName === selectedDatasetName
    );

    if (selectedDataset) {
      setSelectedDataset(selectedDataset.id); // Update the store with selected dataset ID
    } else {
      console.error("Dataset not found");
    }
  };

  return (
    <div className="datasetsDropdownContainer  d-flex justify-content-center gap-5 mb-4">
      {alert && (
        <Alert
          variant={alert.variant}
          onClose={() => setAlert(null)}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <div>
        <h4 className="header px-3 mb-3">
          {" "}
          1) {t("pleaseSelectTheUseCase")} :{" "}
        </h4>
        <DropdownButton
          id="category-selection"
          title={chosenCategoryDisplay}
          bsPrefix="dropDownBtn"
          variant="secondary"
          className="datasetsDropdown"
          onSelect={handleCategorySelection}
        >
          {categories.map((category) => (
            <Dropdown.Item key={category} eventKey={category}>
              {getCategoryDisplayName(category)}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>

      <div>
        <h4 className="header px-3 mb-3">2) {t("pleaseSelectDataset")} : </h4>
        <DropdownButton
          id="dataset-selection"
          title={chosenDataset}
          bsPrefix="dropDownBtn"
          variant="secondary"
          className="datasetsDropdown"
          onSelect={handleDatasetSelection}
          disabled={chosenCategory === "Select Use Case"}
        >
          {filteredDatasets.map((dataset) => (
            <Dropdown.Item key={dataset.id} eventKey={dataset.datasetName}>
              {dataset.datasetName}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
    </div>
  );
};

export default DatasetSelector;
